import { useProductCardHook } from '../hooks/use-product-card.hook'
import { ProductCardInterface } from '../interfaces/product-card.interface'
import type { TProductCardContainer } from '../types/product-card-container.type'

export function ProductCardContainer({
	product,
	layoutType,
	quantityRef,
	inputSearchRef,
	isCalculatingOrder,
	hasOneProduct,
}: TProductCardContainer) {
	const productCardHook = useProductCardHook({ product })

	return (
		<ProductCardInterface
			isCalculatingOrder={isCalculatingOrder}
			hasOneProduct={hasOneProduct}
			inputSearchRef={inputSearchRef}
			productCardInterfaceController={productCardHook}
			layoutType={layoutType}
			quantityRef={quantityRef}
		/>
	)
}
